
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources01On as ObiSources01OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-01-on.js';
 
 
 

 
 export const ObiSources01On = createComponent({
   react: React,
   tagName: 'obi-sources-01-on',
   elementClass: ObiSources01OnElement,
   events: {
     
   }
  });
 
 